// api.ts
import axios from "axios";
import { toast } from "react-toastify";

export const handleApiError = (error: any) => {
  // Check if the error is a network error
  if (error.message === "Network Error" || !navigator.onLine) {
    // For network errors, only log to console
    console.error("Network error:", error);
    return;
  }

  let errorMessage = `Error: ${error.message}`;

  if (error.response) {
    const { data } = error.response;
    errorMessage = `Error: ${
      data.message || error.message || error.responseMessage
    }`;

    if (data.userStatus) {
      errorMessage += ` - ${data.userStatus}`;
    }
  }

  // Display toast for non-network errors
  toast.error(errorMessage);
};

export const fetchServiceCategoryItems = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}GetServiceCategoryItem`
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const addCompanionService = async (
  companionID: string,
  EmailAddress: string,
  companionServiceString: string,
  token: string,
  pageCount: number
) => {
  try {
    const apiUrl = `${process.env.REACT_APP_DEFAULT_URL}/api/front-end/companion-service`;
    const response = await axios.post(
      apiUrl,
      {
        companionID,
        EmailAddress,
        companionServiceName: companionServiceString,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          PageCount: pageCount,
        },
      }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const AddCompanionAvailability = async (
  payload: any,
  token: string,
  pageCount: number
) => {
  try {
    const apiUrl = `${process.env.REACT_APP_DEFAULT_URL}/api/front-end/companion-availability`;
    const response = await axios.post(apiUrl, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        PageCount: pageCount,
      },
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const AddCompanionExperience = async (
  payload: any,
  token: string
  // pageCount: number
) => {
  try {
    const apiUrl = `${process.env.REACT_APP_DEFAULT_URL}/api/front-end/companion-experience`;
    const response = await axios.post(apiUrl, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        // PageCount: pageCount,
      },
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const AddLanguage = async (
  payload: any,
  token: string
  // pageCount: number
) => {
  try {
    const apiUrl = `${process.env.REACT_APP_DEFAULT_URL}/api/front-end/companion-language`;
    const response = await axios.post(apiUrl, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        // PageCount: pageCount,
      },
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const AddEducation = async (
  payload: any,
  token: string,
  pageCount: number
) => {
  try {
    const apiUrl = `${process.env.REACT_APP_DEFAULT_URL}/api/front-end/educational-qualification`;
    const response = await axios.post(apiUrl, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        PageCount: pageCount,
      },
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const AddCredibilityWithUpload = async (
  payload: any,
  token: string,
  pageCount: number
) => {
  try {
    const apiUrl = `${process.env.REACT_APP_DEFAULT_URL}/api/front-end/credibility-with-upload`;
    const response = await axios.post(apiUrl, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        PageCount: pageCount,
      },
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
